export let FieldControlDataAttributes = /*#__PURE__*/function (FieldControlDataAttributes) {
  FieldControlDataAttributes["disabled"] = "data-disabled";
  FieldControlDataAttributes["valid"] = "data-valid";
  FieldControlDataAttributes["invalid"] = "data-invalid";
  FieldControlDataAttributes["touched"] = "data-touched";
  FieldControlDataAttributes["dirty"] = "data-dirty";
  FieldControlDataAttributes["filled"] = "data-filled";
  FieldControlDataAttributes["focused"] = "data-focused";
  return FieldControlDataAttributes;
}({});